<template>
    <div>
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>          
      <!-- Application Header -->
      <header class="c-main-header-nav">
        <div class="c-responsive-container">
          <div class="c-as-block">
            <div class="c-header-btn-holder">
              <!-- Button when menu is available -->
              <button class="c-burger-button" v-on:click="toggleOffcanvas()"><i class="fa fa-bars" aria-hidden="true"></i></button>
              <!-- Button when menu is NOT available -->
              <!-- <button class="c-burger-button" v-on:click="actionDiscardChanges()" v-else><i class="fa fa-times" aria-hidden="true"></i></button> -->
            </div>
            <!-- Header Title -->
            <div class="c-has-view-title">
              <b>{{currentViewName}}</b>
            </div>
          </div>
        </div>
      </header>
      <!-- Application Body content -->
      <main class="c-main-body-wrap">
        <div class="c-responsive-container c-relative c-p-top-10">
          <!-- #region CONTENT HERE -->          
          <!-- Single Event to show -->
          <ul class="c-items-list" v-if="monthFilteredListOfEvents && monthFilteredListOfEvents.length > 0">
            <li class="c-items-for-future-events" v-for="eventItem in monthFilteredListOfEvents" v-bind:key="eventItem.eventUid" v-bind:class="returnClassWithWeekDay(eventItem.eventDate)">
              <div class="c-has-event-title"><b class="c-has-date">{{returnEventDate_dayAndMonth(eventItem)}}</b><i class="fa fa-circle" aria-hidden="true"></i><b>{{eventItem.eventName}}</b></div>
              <!-- <div class="c-has-event-venue-day">
                <div class="c-inner-box"><span class="c-has-day">{{returnEventDate_day(eventItem)}}</span><span>{{returnEventVenue_type(eventItem)}}</span></div>
              </div> -->
              <div class="c-has-small-details">
                <table>
                  <tbody>
                    <tr>
                      <td class="c-col-4"><i class="fa fa-map-marker" aria-hidden="true"></i> {{returnEventVenue_type(eventItem)}}</td>
                      <td class="c-col-4"><i class="fa fa-calendar" aria-hidden="true"></i> {{returnEventDate_fullDate(eventItem)}}</td>
                      <td class="c-col-4"><i class="fa fa-credit-card" aria-hidden="true"></i> Ulaz: {{eventItem.ticketPrice}} {{returnCurrencyType(eventItem)}}</td>
                    </tr>
                    <tr>
                      <td class="c-col-4"><i class="fa fa-users" aria-hidden="true"></i>Karte: {{returnTicketsSold(eventItem)}}</td>
                      <td class="c-col-4"><i class="fa fa-glass" aria-hidden="true"></i>Piće: {{returnDrinkIncome(eventItem)}}</td>
                    </tr>                    
                  </tbody>
                </table>
                <!-- <span><i class="fa fa-calendar" aria-hidden="true"></i> {{returnEventDate_fullDate(eventItem)}}</span>
                <span><i class="fa fa-credit-card" aria-hidden="true"></i> Ulaz: {{eventItem.ticketPrice}} {{returnCurrencyType(eventItem)}}</span> -->
              </div>
              <!-- Go to Reservations button -->
              <div class="c-has-go-to-reservations" v-on:click="openArchivedEventReservations(eventItem)">
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i> <b>Pogledaj rezervacije</b>
              </div>
              <!-- Buttons -->
              <div class="c-has-buttons">
                <button class="c-btn" v-on:click="openArchivedEventDetails(eventItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <!-- <button class="c-btn" v-on:click="openEventReservations(eventItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button> -->
              </div>
            </li>
          </ul>          
          <!-- <ul class="c-items-list" v-if="monthFilteredListOfEvents && monthFilteredListOfEvents.length > 0">
            <li class="c-items-for-future-events" v-for="eventItem in monthFilteredListOfEvents" v-bind:key="eventItem['.key']">
              <div class="c-has-event-title"><b>{{eventItem.eventName}}</b></div>
              <div class="c-has-event-venue-day">
                <div class="c-inner-box"><span class="c-has-day">{{returnEventDate_day(eventItem)}}</span><span>{{returnEventVenue_type(eventItem)}}</span></div>
              </div>
              <div class="c-has-small-details">
                <span><i class="fa fa-calendar" aria-hidden="true"></i> {{returnEventDate_fullDate(eventItem)}}</span>
                <span><i class="fa fa-credit-card" aria-hidden="true"></i> Ulaz: {{eventItem.ticketPrice}} {{returnCurrencyType(eventItem)}}</span>
              </div>
              <div class="c-has-small-details">
                <span><i class="fa fa-users" aria-hidden="true"></i> Broj prodatih karata: ??</span>
              </div>
              <div class="c-has-small-details">
                <span><i class="fa fa-glass" aria-hidden="true"></i> Bruto prodaja pica: ??? RSD</span>
              </div>
              <div class="c-has-buttons">
                <button class="c-btn" v-on:click="openArchivedEventDetails(eventItem)"><i class="fa fa-cog" aria-hidden="true"></i></button>
                <button class="c-btn" v-on:click="openArchivedEventReservations(eventItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </div>
            </li>
          </ul> -->
          <!-- No content message -->
          <emo-well-comp 
            v-else
            input-well-type="no-content" 
            input-txt-msg="Trenutno nema zakazanih događaja"
          ></emo-well-comp>          
          <!-- #endregion CONTENT HERE -->          
          <!-- #region CONTENT HERE -->          
          <!-- Single Event to show -->
          <!-- <ul class="c-items-list" v-if="mainListOfItemsForView">
            <li class="c-items-for-future-events" v-for="eventItem in mainListOfItemsForView">
              <div class="c-has-event-title"><i class="fa fa-check-circle c-ux-color-success" aria-hidden="true"></i> <b>{{eventItem.eventName}}</b></div>
              <div class="c-has-event-venue-day">
                <div class="c-inner-box"><span class="c-has-day">Subota</span><span>Letnja basta</span></div>
              </div>
              <div class="c-has-small-details">
                <span><i class="fa fa-calendar" aria-hidden="true"></i> 31. Decembar 2017</span>
                <span><i class="fa fa-credit-card" aria-hidden="true"></i> Ulaz: 100 RSD</span>
              </div>
              <div class="c-has-small-details">
                <span><i class="fa fa-users" aria-hidden="true"></i> Broj prodatih karata: 587</span>
              </div>
              <div class="c-has-small-details">
                <span><i class="fa fa-glass" aria-hidden="true"></i> Bruto prodaja pica: 387384 RSD</span>
              </div>              
              <div class="c-has-buttons">
                <button class="c-btn" v-on:click="openArchivedEventDetails(eventItem)"><i class="fa fa-cog" aria-hidden="true"></i></button>
                <button class="c-btn" v-on:click="openArchivedEventReservations(eventItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </div>
            </li>
          </ul> -->
          <!-- #endregion CONTENT HERE -->
        </div>
      </main>      
      <!-- Application Footer Menu -->
      <footer class="c-main-footer-nav c-white-back">
        <div class="c-responsive-container c-relative">
          <!-- Events filter by month -->
          <div class="c-footer-form-wrap">
            <table v-if="tempListOfAllScheduledMonths && tempListOfAllScheduledMonths.length > 0">
              <tbody>
                <tr>
                  <td class="c-col-6">Prikaži po mesecima</td>
                  <td class="c-col-6">
                    <div class="c-form-group">
                      <select v-model="selectedMonthFilter" class="c-form-control" id="filter-year-month" name="filter-year-month">
                        <option v-bind:value="null">Svi meseci</option>
                        <option v-for="singleYearMonth in tempListOfAllScheduledMonths"
                          :key="singleYearMonth"
                        >{{singleYearMonth}}</option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </footer>
      <!-- Modal Templates -->
      <transition name="slide-up" mode="out-in">
        <component 
          v-if="modalComponent.isVisible" 
          v-bind:is="modalComponent.activeModalComponent"
          v-bind:input-modal-data = "modalComponent.dataForModal"
        ></component>
      </transition>      
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import FooterNavList from '@/components/footer/FooterNavList'
import EmoWellComp from '@/components/wells/EmoWellComp'
import ModalArchivedEventDetails from '@/components/eventsArchive/ModalArchivedEventDetails'
import ModalArchivedEventReservations from '@/components/eventsArchive/ModalArchivedEventReservations'
import OverlayLoader from "@/components/helpers/OverlayLoader";

import moment from 'moment'
import {firebaseDB} from '@/firebase';
export default {
  name: 'EventsArchive',
  props: [
    "inputFirebaseUser",
    "inputListOfRegularGuests",
    "inputListOfVenueTypes",
    "inputListOfCurrencyUnits",
    "inputListOfWaiters",
    "inputTableStatusEnums"
  ],
  components: {
    FooterNavList: FooterNavList,
    EmoWellComp: EmoWellComp,
    ModalArchivedEventDetails: ModalArchivedEventDetails,
    ModalArchivedEventReservations: ModalArchivedEventReservations,
    OverlayLoader: OverlayLoader
  },
  data () {
    return {
      // ~ name of current view (component title)
      currentViewName: null,
      tempListOfAllVenues: {},
      tempListOfCurrencyUnits: {},
      //
      tempListOfAllScheduledMonths: [],
      selectedMonthFilter: null,
      // ~ each time we have loading process this array will have length > 0
      isLoading: [1],
      // ~ for showing modal
      modalComponent: {
        isVisible: false,
        activeModalComponent: null,
        dataForModal: null
      }
    }
  },
  firebase: function () {
    return {
      listOfArchivedEvents: {
        source: firebaseDB.ref('listOfArchivedEvents'),
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          //use Lodash to sort list by date ascending
          //this.listOfArchivedEvents = _.orderBy(dataSnapshot.val(), 'eventDate', 'asc');
          //call function          
          this.getListOfAllScheduledMonths(dataSnapshot.val());
          this.isLoading.pop();
        }
      }      
    }
  },  
  watch: {
    selectedMonthFilter: function (newValue) {
      //console.log('selected month filter: ' + newValue);
    }
  },
  computed: {
    monthFilteredListOfEvents: function () {
      if (!this.selectedMonthFilter){
        return this.listOfArchivedEvents;
      }else{
        return this.listOfArchivedEvents.filter((eventItem)=>{
          if (eventItem.eventDate){
            var eventMonth = moment(eventItem.eventDate).format('MMMM, YYYY');
            if (eventMonth === this.selectedMonthFilter){
              return true;
            }else{
              return false;
            }
          }else{
            return false;
          }
        });
      }
    }
  },      
  methods: {
    // ~ hide offcanvas component inside 'MainApp' component
    toggleOffcanvas: function (){
      EventBus.$emit('toggleOffcanvas');
    },
    // ~ get all months in which we have events
    getListOfAllScheduledMonths: function (inputListOfEvents) {
      //console.log('... initialized -- getListOfAllScheduledMonths()')
      this.tempListOfAllScheduledMonths = [];
      // if (inputEventObject && inputEventObject.eventDate) {
      //   returnDay = moment(inputEventObject.eventDate).format("DD. MMM");
      // }
      for (var key in inputListOfEvents) {
        if (inputListOfEvents.hasOwnProperty(key) && inputListOfEvents[key].eventDate) {
          //console.log('key is: ' + inputListOfEvents[key].eventDate);
          var doesMonthExist = false;
          for (var i = 0; i < this.tempListOfAllScheduledMonths.length; i++){
            if (this.tempListOfAllScheduledMonths[i] === moment(inputListOfEvents[key].eventDate).format('MMMM, YYYY') ){
              doesMonthExist = true;
              break;
            }
          }
          if (doesMonthExist === false){
            var newMonth = moment(inputListOfEvents[key].eventDate).format('MMMM, YYYY');
            this.tempListOfAllScheduledMonths.push(newMonth)
          }
        }
      }
      ///
      //console.log('organized list: ' + JSON.stringify(this.tempListOfAllScheduledMonths, null, 2) )
    },    
    /* #region Event Details Modal */
    // ~ when user wants to change details for some event
    openArchivedEventDetails: function (inputEventItem) {
      //console.log('inputEventItem: ' + JSON.stringify(inputEventItem, null, 2) );
      var tempBackupEventItem = JSON.parse(JSON.stringify(inputEventItem));
      //
      var eventKey = inputEventItem.eventUid;
      var eventReservationsKey = tempBackupEventItem.eventReservationsKey;
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_EventDetails(inputEventItem).then(
        function(response){
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          if (response && response.actionStatus == "event-delete-completely" && eventKey && eventReservationsKey) {
            //show loader
            this.isLoading.push(1);
            //console.log('tempBackupEventItem: ' + JSON.stringify(tempBackupEventItem, null, 2) );
            //save key id for this event that we want to completely delete
            //console.log('ready data, eventKey: ' + eventKey + ', eventReservationsKey: ' + eventReservationsKey);
            //call firebase api and delete event with that id
            firebaseDB.ref("listOfArchivedEvents").child(eventKey).remove().then(
              function(response) {
                firebaseDB.ref("listOfAllEventsReservations").child(eventReservationsKey).remove().then(
                  function(response) {
                    this.isLoading.pop();
                    this.closeModal();
                  }.bind(this),
                  function(error) {
                    // ~ close modal
                    this.isLoading.pop();
                    console.log('Error. We tried to delete Archived event RESERVATIONS: ' + eventReservationsKey + ' but something went wrong!')
                    this.closeModal();
                  }.bind(this)
                );                
              }.bind(this),
              function(error) {
                this.isLoading.pop();
                this.closeModal();                
                console.log('Error. We tried to delete Archived event: ' + eventKey + ' but something went wrong!')
              }.bind(this)
            );
          } else {
            // ~ close modal
            this.closeModal();
          }          
        }.bind(this),
        function(reject){
          console.log('Modal returned reject');
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_EventDetails: function (inputEventItem) {
      return new Promise ((resolve, reject)=>{
        this.modalComponent.activeModalComponent = ModalArchivedEventDetails;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
            headerTitle: 'Event Details Title',
            dataForModal: {
              selectedEventObject: inputEventItem,
              listOfVenueTypes: this.inputListOfVenueTypes,
              listOfCurrencyUnits: this.inputListOfCurrencyUnits
            },            
            resolve: resolve,
            reject: reject
        }
      });
    },
    /* #endregion Event Details Modal */
    /* #region Event Reservations Modal */
    // ~ when user wants to change Reservations for some event
    openArchivedEventReservations: function (inputEventItem) {
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_EventReservations(inputEventItem).then(
        function(response){
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject){
          console.log('Modal returned reject');
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_EventReservations: function (inputEventItem) {
      return new Promise ((resolve, reject)=>{
        this.modalComponent.activeModalComponent = ModalArchivedEventReservations;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
            headerTitle: 'Event Reservations Title',
            dataForModal: {
              selectedEventObject: inputEventItem,
              listOfRegularGuests: this.inputListOfRegularGuests,
              listOfVenueTypes: this.inputListOfVenueTypes,              
              listOfCurrencyUnits: this.inputListOfCurrencyUnits,
              listOfWaiters: this.inputListOfWaiters,
              tableStatusEnums: this.inputTableStatusEnums,
              currentFirebaseUser: this.inputFirebaseUser
            },
            resolve: resolve,
            reject: reject
        }
      });
    },    
    /* #endregion Event Reservations Modal */
    //
    returnEventDate_day: function (inputEventObject) {
      var returnDay = 'Nedefinisan'
      if (inputEventObject && inputEventObject.eventDate){
        returnDay = moment(inputEventObject.eventDate).format('dddd');
      }
      //
      return returnDay;
    },
    returnEventDate_fullDate: function (inputEventObject) {
      var returnDate = 'Nedefinisan'
      if (inputEventObject && inputEventObject.eventDate){
        returnDate = moment(inputEventObject.eventDate).format('DD. MMMM YYYY.');
      }
      //
      return returnDate;
    },
    returnEventDate_dayAndMonth: function(inputEventObject) {
      var returnDay = "Unk";
      if (inputEventObject && inputEventObject.eventDate) {
        returnDay = moment(inputEventObject.eventDate).format('DD. MMM')
      }
      //
      return returnDay;
    },    
    //
    returnEventVenue_type: function (inputEventObject) {
      var returnValue = 'Nedefinisan';
      if (inputEventObject && inputEventObject.eventVenue){
        //console.log('this.inputListOfVenueTypes: ' + JSON.stringify(this.inputListOfVenueTypes, null, 2) );
        for (var key in this.inputListOfVenueTypes) {
          if (this.inputListOfVenueTypes.hasOwnProperty(key)) {
            if (key == inputEventObject.eventVenue && this.inputListOfVenueTypes[key].name){
              //console.log('name is this: ' + this.inputListOfVenueTypes[key].name);
              returnValue = this.inputListOfVenueTypes[key].name;
            }
          }
        }   
      }
      return returnValue;
    },
    returnCurrencyType: function(inputEventObject) {
      var returnValue = "--";
      if (
        inputEventObject &&
        inputEventObject.ticketPriceCurrency &&
        this.tempListOfCurrencyUnits
      ) {
        for (var key in this.tempListOfCurrencyUnits) {
          if (this.tempListOfCurrencyUnits.hasOwnProperty(key)) {
            if (
              key == inputEventObject.ticketPriceCurrency &&
              this.tempListOfCurrencyUnits[key].title
            ) {
              //console.log('name is this: ' + this.inputListOfVenueTypes[key].name);
              returnValue = this.tempListOfCurrencyUnits[key].title;
            }
          }
        }
      }
      return returnValue;
    }, 
    returnTicketsSold: function (inputEventObject) {
      var returnValue = "--";
      if (inputEventObject && inputEventObject.ticketsSold) {
        returnValue = inputEventObject.ticketsSold;
      }
      return returnValue;
    }, 
    returnDrinkIncome: function (inputEventObject) {
      var returnValue = "--";
      if (inputEventObject && inputEventObject.drinkIncome) {
        returnValue = inputEventObject.drinkIncome;
      }
      return returnValue;
    },     
    closeModal: function (){
      this.modalComponent.isVisible = false;
      this.modalComponent.activeModalComponent = null;
      this.modalComponent.dataForModal = null;
    },
    ////
    returnClassWithWeekDay: function (inputedEventDate) {
      let returnClass = '';
      if (inputedEventDate){
        returnClass = 'c-' + moment(inputedEventDate).format('dddd').toLowerCase();
      }
      return returnClass;
    } 
  },
  created () {
    //console.log('~ created- EventsArchive component!');
    //
    if (this.inputListOfVenueTypes) {
      //console.log('this.inputListOfVenueTypes: ' + JSON.stringify(this.inputListOfVenueTypes, null, 2) );
      this.tempListOfAllVenues = this.inputListOfVenueTypes;
    }
    if (this.inputListOfCurrencyUnits) {
      //console.log('this.inputListOfCurrencyUnits: ' + JSON.stringify(this.inputListOfCurrencyUnits, null, 2) );
      this.tempListOfCurrencyUnits = this.inputListOfCurrencyUnits;
    }    
    // ~ call action when router is ready
    this.$router.onReady(function () {
      if (this.$route.meta) {
        this.currentViewName = this.$route.meta.headerTitle
      }
    }.bind(this));    
  },
  mounted () {
    //console.log('~ mounted - EventsArchive component!');
  },
  destroyed () {
    //console.log('~ destroyed- EventsArchive component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/eventsArchive/EventsArchive.vue